import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface ApiResponse {
  statusCode: string,
  taskName: string,
  taskRun: string
}

@Injectable({
  providedIn: 'root'
})
export class TasksService {

  constructor(private http: HttpClient) { }

  getTasks(pipelinerun: string): Observable<[ApiResponse]> {
    let thisUrl = '/assets/' + pipelinerun + '/tasks.json';
    
    return this.http.get<[ApiResponse]>(thisUrl);
  }

  getTaskLog(pipelinerun: string, task: string): Observable<string> {
    let thisUrl = '/assets/' + pipelinerun + '/' + task + '/logs.txt';
    return this.http.get(thisUrl, { responseType: 'text' });
  }

  getTaskYaml(pipelinerun: string, task: string): Observable<string> {
    let thisUrl = '/assets/' + pipelinerun + '/' + task + '/taskrun.yaml';
    return this.http.get(thisUrl, { responseType: 'text' });
  }

  getPipelineYaml(pipelinerun: string): Observable<string> {
    let thisUrl = '/assets/' + pipelinerun + '/pipelinerun.yaml';
    return this.http.get(thisUrl, { responseType: 'text' });
  }
}